<template>
  <div>
    <slot name="prefix" />
    <v-row>
      <v-col
        v-show="!(personsOnly || firmsOnly || isTableData || isGovernmentalUser ||isGovSubRequest)"
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="mainRequestDetailsTypes !== mainRequestDetailsTypesEnum.interestedParties ? `${locale.partyType} ${personTitle}` : `${locale.interestTypeLabel}`"
          :value.sync="formModel.typeId"
          :value-name.sync="formModel.partyTypeName"
          :items="partyTypes"
          item-text="name"
          item-value="id"
          :disabled="viewMode || validating || isEditMode"
          validates="required"
          @change="partyTypeChanged"
        ></naj-input>
      </v-col>

      <template v-if="isPerson">
        <div
          v-if="!isTableData"
          class="row mx-0"
        >
          <v-col
            v-if="!saudiOnly"
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="!!personTitle ? `${locale.identityTypeIdForPerson} ${personTitle}` : locale.identityTypeId"
              :value.sync="formModel.identityTypeId"
              :items="identityTypes"
              item-text="name"
              item-value="id"
              :disabled="viewMode || validating || isLawyer || isEditMode"
              validates="required"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              v-mask="identityNumberMask"
              :type-id="formFieldType.text"
              :label="!!personTitle ? `${locale.identityNumberForPeron} ${personTitle}` : locale.identityNumber"
              :value.sync="formModel.identityNumber"
              :disabled="viewMode || validating || !formModel.identityTypeId || isLawyer || isEditMode"
              :validates="`long|digits:10|isVerified:${isVerified}${requiredValidation}|socialId:${formModel.identityTypeId}`"
              @input="identityNumberChanged"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="12"
            lg="6"
          >
            <naj-input
              :form-key="formKey"
              :technical-name="personTitle || formKey"
              :label="locale.dateOfBirth"
              :type-id="formFieldType.date"
              :value.sync="formModel.dateOfBirth"
              :disabled="viewMode || validating || isVerified ||!formModel.identityTypeId || isLawyer || isEditMode"
              @change="dateOfBirthChanged"
            ></naj-input>
          </v-col>
        </div>

        <div
          v-if="!isTableData"
          class="row mx-0"
        >
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="!!personTitle && !isRepresentative ? `${locale.name} ${personTitle}` : locale.firstName"
              :value.sync="formModel.firstName"
              :disabled="viewMode || validating || isVerified ||!formModel.identityTypeId || isLawyer || isEditMode"
              :validates="`${requiredValidation}`"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.fatherName"
              :value.sync="formModel.fatherName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            :lg="viewMode || isVerified ?3 : 2"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.thirdName"
              :value.sync="formModel.thirdName"
              :disabled="true"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            :lg="viewMode || isVerified ?3 : 2"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.familyName"
              :value.sync="formModel.familyName"
              :disabled="true"
            ></naj-input>
          </v-col>

          <v-col
            v-if="!viewMode && !isVerified"
            cols="12"
            md="6"
            :lg="2"
            class="d-flex align-center"
          >
            <naj-button
              square
              inputs-alignment
              :loading="validating"
              :disabled="viewMode || isVerified || !formModel.identityNumber || (!formModel.dateOfBirth && !formModel.firstName)"
              @click="validateIdentityNumber"
            >
              {{ locale.validateIdentityNumber }}
            </naj-button>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>{{ locale.personVerify }}</span>
            </v-tooltip>
          </v-col>
        </div>

        <div
          v-if="isTableData"
          class="row mx-0"
        >
          <v-col cols="12">
            <naj-data-table
              no-header
              :headers="headers"
              :items="tableData"
              :disable-items-per-page="true"
              no-margin-bottom
            >
            </naj-data-table>
          </v-col>
        </div>
        <template v-if="mainRequestDetailsTypes == mainRequestDetailsTypesEnum.interestedParties && !isTableData">
          <slot name="interestedParty" />
        </template>
      </template>
      <template v-if="isFirm || isOrganization">
        <v-col
          v-if="!isTableData"
          cols="12"
          :md="viewMode || isVerified ?6 : 4"
          lg="4"
        >
          <naj-input
            :key="formKey"
            v-mask="'7#########'"
            :form-key="formKey"
            :type-id="formFieldType.number"
            :label="locale.unifiedNumber"
            :value.sync="formModel.unifiedNumber"
            :validates="`long|isVerified:${isVerified}${requiredValidation}`"
            :disabled="viewMode || validating || isEditMode"
            @input="commercialRegistrationNumberChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-if="showMangerSocialId && !isTableData"
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="socialIdOwnerName"
            :value.sync="socialId"
            :validates="managerSocialIdRequired?`required|isVerified:${isVerified}${requiredValidation}`:''"
            :disabled="viewMode || validating || isEditMode"
            @input="commercialRegistrationNumberChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-if="!viewMode && !isVerified && !isTableData"
          class="d-flex align-center"
          cols="12"
          md="2"
          lg="2"
        >
          <naj-button
            square
            inputs-alignment
            :loading="validating"
            :disabled="disableCheckButton"
            @click="validateCommercialRegistrationNumber"
          >
            {{ locale.validateIdentityNumber }}
          </naj-button>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                large
                v-bind="attrs"
                v-on="on"
              >
                mdi-information
              </v-icon>
            </template>
            <span>{{ locale.nonPersonVerify }}</span>
          </v-tooltip>
        </v-col>
        <template v-if="isVerified && !isTableData">
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.commercialRegistrationNumber"
              :value.sync="formModel.commercialRegistrationNumber"
              disabled
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="`${locale.name} ${personTitle ? personTitle : 'ال'+formModel.partyTypeName}`"
              :value.sync="formModel.organizationName"
              disabled
            ></naj-input>
          </v-col>
        </template>

        <template v-if="isOrganization && !isTableData">
          <v-col
            v-if="!!formModel.managerFullName"
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.managerFullName"
              :value.sync="formModel.managerFullName"
              disabled
            ></naj-input>
          </v-col>
          <v-col
            v-if="!!formModel.managerIdentityNumber"
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.managerIdentityNumber"
              :value.sync="formModel.managerIdentityNumber"
              disabled
            ></naj-input>
          </v-col>
        </template>

        <v-col
          v-if="isTableData"
          cols="12"
        >
          <naj-data-table
            no-header
            :headers="headers"
            :items="tableData"
            :disable-items-per-page="true"
            no-margin-bottom
          >
          </naj-data-table>
        </v-col>
        <template v-if="mainRequestDetailsTypes == mainRequestDetailsTypesEnum.interestedParties && !isTableData">
          <slot name="interestedParty" />
        </template>
      </template>
      <template v-if="isForeignCompany">
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <naj-input
            :key="formKey"
            :form-key="formKey"
            :type-id="formFieldType.text"
            :label="locale.commercialRegistrationNumber"
            :value.sync="formModel.commercialRegistrationNumber"
            :validates="`long|required`"
            :disabled="viewMode || isEditMode"
            @blur="CommercialRegistrationNumberRetrieve"
          ></naj-input>
        </v-col>
        <v-col
          cols="12"
          lg="6"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="locale.companyName"
            :value.sync="formModel.organizationName"
            :validates="`required`"
            :disabled="viewMode || isEditMode"
          ></naj-input>
        </v-col>
        <v-col cols="12">
          <manager-info
            :form-model="formModel"
            :loading="validating"
            :is-edit-mode="isEditMode"
            :is-view-mode="viewMode"
            @manager-validated="managerValidated"
          ></manager-info>
        </v-col>
        <template v-if="mainRequestDetailsTypes == mainRequestDetailsTypesEnum.partners">
          <slot name="partner" />
        </template>
        <template v-if="mainRequestDetailsTypes == mainRequestDetailsTypesEnum.interestedParties">
          <slot name="interestedParty" />
        </template>
      </template>

      <template v-if="isGovernment && !(isGovernmentalUser || isGovSubRequest)">
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="locale.governmentAgencyName"
            :value.sync="formModel.organizationId"
            :value-name.sync="formModel.organizationName"
            :items="organizationsByPartyType"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="viewMode || isEditMode"
            @change="governmentalAgencyChanged"
          ></naj-input>
        </v-col>
        <template v-if="mainRequestDetailsTypes == mainRequestDetailsTypesEnum.interestedParties">
          <slot name="interestedParty" />
        </template>
      </template>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
import { uuidGenerator } from '@/helpers/utils';
import {
  requestOwnerTypeEnum, mainRequestDetailsTypesEnum, partyTypeEnum, identityTypeEnum,
  identityTypes, partyTypeNames,
} from '@/modules/bankruptcy/helpers/enum';
const { mapState: mapLUTState, mapActions } = createNamespacedHelpers(
  'LookupsModule'
);
const { mapActions: mapBankruptcyActions, mapState } = createNamespacedHelpers('BankruptcyModule');
import ManagerInfo from '../request/steps/request-details/manager-info.vue';

export default {
  inject: ['$validator'],
  components: { ManagerInfo },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    personTitle: {
      type: String,
      required: true,
      default: null,
    },
    viewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTableData: {
      type: Boolean,
      required: false,
      default: false,
    },
    personsOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    firmsOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    saudiOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    isOptional: {
      type: Boolean,
      required: false,
      default: false,
    },
    managerSocialIdRequired: {
      required: false,
      type: Boolean,
      default: false,
    },
    isLawyer: {
      type: Boolean,
      required: false,
      default: false,
    },
    requestOwnerTypeId: {
      type: Number,
      required: false,
      default: null,
    },
    mainRequestDetailsTypes: {
      type: Number,
      required: false,
      default: null,
    },
    isEditMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    isGovSubRequest: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      formKey: uuidGenerator(),
      locale: this.local.bankruptcy.identityVerificationForm,
      validating: false,
      partyType: null,
      socialId: null,
      identityTypeEnum,
      identityTypes: null,
      headers: [],
      firmHeader: [
        {
          value: 'organizationName',
          text: this.local.bankruptcy.identityVerificationForm.theName,
        },
        {
          value: 'unifiedNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.unifiedNumber,
        },
        {
          value: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.commercialRegistrationNumber,
        },
      ],
      personHeader: [
        {
          value: 'fullName',
          text: this.local.bankruptcy.identityVerificationForm.theName,
        },
        {
          value: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.partners.identityNumber,
        },
        {
          value: 'identityTypeName',
          text: this.local.bankruptcy.requestDetails.partners.identityType,
        },
      ],
      tableData: [],
      partyTypeEnum,
      requestOwnerTypeEnum,
      mainRequestDetailsTypesEnum,
      identityTypes: Object.keys(identityTypeEnum)
        .map(pt => ({
          id: identityTypeEnum[pt],
          name: this.local.bankruptcy.common[pt],
        })),
    };
  },
  computed: {
    ...mapLUTState([
      'governmentAgencies',
    ]),
    ...mapState(['currentUser']),
    identityNumberMask() {
      return !this.formModel.identityTypeId ? '' : `${this.formModel.identityTypeId}#########`;
    },
    isVerified() { return this.formModel.isIdentityVerified; },
    requiredValidation() {
      return this.isOptional ? '' : '|required';
    },
    isPerson() {
      return this.formModel.typeId == partyTypeEnum.person;
    },
    isFirm() {
      return this.formModel.typeId == partyTypeEnum.firm;
    },
    isOrganization() {
      return this.formModel.typeId == partyTypeEnum.organization;
    },
    isForeignCompany() {
      return this.formModel.typeId == partyTypeEnum.foreignCompany;
    },
    isGovernment() {
      return this.formModel.typeId == partyTypeEnum.government;
    },
    socialIdOwnerName() {
      return this.isFirm ? this.locale.firmManagerIdentityNumber : this.locale.managerIdentityNumber;
    },
    disableCheckButton() {
      return this.viewMode || this.isVerified || (!this.formModel.unifiedNumber || (!this.isOrganization && this.managerSocialIdRequired && !this.socialId));
    },
    showMangerSocialId() {
      return !this.viewMode && !this.isVerified && !this.isOrganization;
    },
    isRepresentative() {
      return this.personTitle === this.local.bankruptcy.subRequests.representative;
    },
    forSubRequest() {
      return this.$route.params.requestType ? true : false;
    },
    partyTypes() {
      let types = Object.keys(partyTypeEnum)
        .map(pt => ({
          id: partyTypeEnum[pt],
          name: this.local.bankruptcy.common[pt],
        }));
      if (this.requestOwnerTypeId == requestOwnerTypeEnum.debtor && (this.mainRequestDetailsTypes == mainRequestDetailsTypesEnum.bankruptDebts || this.mainRequestDetailsTypes == mainRequestDetailsTypesEnum.bankruptDueRights)) {
        return types;
      }
      else if (this.requestOwnerTypeId == requestOwnerTypeEnum.creditor || this.requestOwnerTypeId == requestOwnerTypeEnum.debtor && (this.mainRequestDetailsTypes == mainRequestDetailsTypesEnum.partners || this.mainRequestDetailsTypes == mainRequestDetailsTypesEnum.interestedParties) || this.forSubRequest) {
        let nonRequiredTypes = [partyTypeEnum.government];
        return types.filter(x => !nonRequiredTypes.includes(x.id));
      }
      else {
        let requiredTypes = [partyTypeEnum.person, partyTypeEnum.firm, partyTypeEnum.organization];
        return types.filter(x => requiredTypes.includes(x.id));
      }
    },
    organizationsByPartyType() {
      return this.governmentAgencies.map(x => ({
        id: x.id,
        name: x.organizationName,
      }));
    },
    isGovernmentalUser() {
      return this.currentUser.loginType == 'governmental';
    },
  },
  watch: {
    'formModel.typeId'(newValue) {
      if (this.personsOnly) {
        this.$set(this.formModel, 'typeId', partyTypeEnum.person);
        this.$nextTick(() => { this.$emit('partyTypeChanged', partyTypeEnum.person); });
      }
      if (this.firmsOnly) {
        this.$set(this.formModel, 'typeId', partyTypeEnum.firm);
        this.$nextTick(() => { this.$emit('partyTypeChanged', partyTypeEnum.firm); });
      }
      if (newValue == partyTypeEnum.foreignCompany) {
        this.$set(this.formModel, 'typeId', partyTypeEnum.foreignCompany);
        this.$nextTick(() => { this.$emit('partyTypeChanged', partyTypeEnum.foreignCompany); });
      }
    },
    'formModel.identityTypeId'() {
      if (this.saudiOnly) {
        this.$set(this.formModel, 'identityTypeId', identityTypeEnum.nationalId);
        this.$set(this.formModel, 'identityTypeName', this.local.bankruptcy.common[identityTypes[identityTypeEnum.nationalId]]);
        this.$nextTick(() => { this.$emit('identityTypeIdChanged', identityTypeEnum.nationalId); });
      }
    },
    showMangerSocialId(value) {
      if (!value)
        this.socialId = null;
    },
  },
  created() {
    this.getGovernmentAgencies();
    if (this.personsOnly) {
      this.$set(this.formModel, 'typeId', partyTypeEnum.person);
      this.$nextTick(() => { this.$emit('partyTypeChanged', partyTypeEnum.person); });
    }
    if (this.saudiOnly) {
      this.$set(this.formModel, 'identityTypeId', identityTypeEnum.nationalId);
      this.$set(this.formModel, 'identityTypeName', this.local.bankruptcy.common[identityTypes[identityTypeEnum.nationalId]]);
      this.$nextTick(() => { this.$emit('identityTypeIdChanged', identityTypeEnum.nationalId); });
    }
    if (this.firmsOnly) {
      this.$set(this.formModel, 'typeId', partyTypeEnum.firm);
      this.$nextTick(() => { this.$emit('partyTypeChanged', partyTypeEnum.firm); });
    }
  },
  mounted() {
    this.socialId = this.formModel.socialId;
    this.$set(this.formModel, 'typeName', this.local.bankruptcy.common[partyTypeNames[this.formModel.typeId]]);
    const customFirmHeaders = this.formModel?.commercialRegistrationNumber ? this.firmHeader : this.firmHeader.filter(h => h.value != 'commercialRegistrationNumber');
    this.headers = this.isPerson ? this.personHeader : customFirmHeaders;
    this.tableData.push(this.formModel);
    let socialTypes = {
      nationalId: 1,
      regularResidency: 2,
    };
    this.identityTypes = Object.keys(socialTypes)
      .map(pt => ({
        id: identityTypeEnum[pt],
        name: this.local.bankruptcy.common[pt],
      }));
  },
  methods: {
    ...mapActions(['getGovernmentAgencies']),
    ...mapSysActions(['checkMOIPersonalInfo', 'checkCommercialRegistrationNumber']),
    ...mapBankruptcyActions(['getFirmByCommercialRegistrationNumber']),
    partyTypeChanged(value) {
      this.partyType = value;
      this.resetVerification();
      const props = [
        'identityTypeId', 'identityNumber', 'dateOfBirth', 'firstName', 'fatherName', 'thirdName', 'familyName',
        'commercialRegistrationNumber', 'organizationName', 'unifiedNumber', 'managerIdentityNumber', 'managerFullName',
        'nationality', 'gender', 'manager'];
      props.forEach((prop) => { this.$set(this.formModel, prop, undefined); });
      this.$emit('partyTypeChanged', value);
    },
    CommercialRegistrationNumberRetrieve() {
      this.$set(this.formModel, 'isIdentityVerified', false);
      if (this.forSubRequest) {
        const payload = {
          mainRequestObjectKey: this.$route.params.mainRequestObjectKey,
          commercialRegistrationNumber: this.formModel.commercialRegistrationNumber,
        };
        this.getFirmByCommercialRegistrationNumber(payload)
          .then((res) => {
            const firm = res.data;
            if (firm.id) {
              this.$set(this.formModel, 'isIdentityVerified', true);
              this.$emit('isIdentityVerified', true);
            }
          });
      }
    },
    identityNumberChanged() {
      var props = ['firstName', 'fatherName', 'thirdName', 'familyName', 'nationality', 'gender', 'dateOfBirth'];
      props.forEach((prop) => { this.$set(this.formModel, prop, undefined); });
      this.resetVerification();
    },
    commercialRegistrationNumberChanged() {
      this.resetVerification();
      var props = ['organizationName', 'commercialRegistrationNumber', 'managerIdentityNumber', 'managerFullName'];
      props.forEach((prop) => { this.$set(this.formModel, prop, undefined); });
    },
    resetVerification() {
      this.$set(this.formModel, 'isIdentityVerified', false);
      this.$emit('isIdentityVerified', false);
    },
    validateIdentityNumber() {
      const personalInfoRequest = {
        socialId: this.formModel.identityNumber,
        dateOfBirth: this.formModel.dateOfBirth,
        firstName: !this.formModel.dateOfBirth ? this.formModel.firstName : null,
      };
      this.validating = true;
      var props = ['firstName', 'fatherName', 'thirdName', 'familyName', 'nationality', 'gender'];
      props.forEach((prop) => { this.$set(this.formModel, prop, undefined); });
      this.checkMOIPersonalInfo(personalInfoRequest)
        .then((personalInfo) => {
          debugger;
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          props.forEach((prop) => { this.$set(this.formModel, prop, personalInfo[prop]); });
          this.$set(this.formModel, 'isIdentityVerified', true);
          this.$emit('isIdentityVerified', true);
          this.$emit('verifiedIdentityNumber', this.formModel);
        })
        .catch(() => {
          debugger;
          this.toaster.error(this.local.personInformation.checkPersonalInfoError);
          this.resetVerification();
        })
        .finally(() => { debugger; this.validating = false; });
    },
    validateCommercialRegistrationNumber() {
      const companyRequest = {
        commercialRegistrationNumber: this.formModel.unifiedNumber,
        socialId: this.socialId || ' ',
        partyType: this.formModel.typeId,
      };
      this.validating = true;
      var props = ['organizationName', 'commercialRegistrationNumber', 'unifiedNumber', 'managerIdentityNumber', 'managerFullName'];
      props.forEach((prop) => { this.$set(this.formModel, prop, undefined); });
      this.checkCommercialRegistrationNumber(companyRequest)
        .then((companyInfo) => {
          const status = companyInfo?.response?.status;
          if (status === 400) {
            this.resetVerification();
            this.socialId = null;
            return;
          }
          if (companyInfo.commercialRegistrationTypeId === 1) {
            const mainCRText = companyInfo.mainCRUnifiedNumber
              ? ` ورقمه ${companyInfo.mainCRUnifiedNumber}`
              : '';
            this.toaster.error(
              this.partyType == partyTypeEnum.organization
                ? this.local.bankruptcy.subRequests.prohibitedInstitutionCommercialType({
                  unifiedNumber: mainCRText,
                  name: companyInfo.organizationName,
                })
                :
                this.local.bankruptcy.subRequests.prohibitedCompanyCommercialType({
                  unifiedNumber: mainCRText,
                  name: companyInfo.organizationName,
                }),
              3000
            );
            return;
          }
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          props.forEach((prop) => { this.$set(this.formModel, prop, companyInfo[prop]); });
          this.$set(this.formModel, 'isIdentityVerified', true);
          this.$emit('isIdentityVerified', true);
        })
        .catch((error) => {
          const status = error?.response?.status;
          if (status === 404) {
            this.toaster.error(this.local.organizationData.checkCommercialRegistrationNumberError);
          }
          this.resetVerification();
          this.socialId = null;
        })
        .finally(() => { this.validating = false; });
    },
    dateOfBirthChanged() {
    },
    governmentalAgencyChanged() {
      const selectedAgency = this.governmentAgencies.find(ga => ga.id == this.formModel.organizationId);
      if (selectedAgency) {
        this.$set(this.formModel, 'unifiedNumber', selectedAgency.unifiedNumber);
      }
      else {
        this.$set(this.formModel, 'unifiedNumber', null);
      }
    },
    managerValidated(value) {
      this.$set(this.formModel, 'isIdentityVerified', !!value);
      this.$emit('isIdentityVerified', !!value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
